import React, { useState, useRef, useEffect } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AuthService from '../../services/auth.service'
import { Checkbox } from '@mui/material'
import PreLogin from '../../layout/preLogin'
import { MuiTextField, MuiButton, Loader } from '../../components'
import { ROUTE_PROJECTS, ROUTE_RESET_PASSWORD } from '../../constants'
import {
  LoginButton,
  LoginContent1,
  LoginContent2,
  FormControlLabelWrapper,
  ErrorMsg,
  PasswordInputWrap,
  EmailInputWrap,
} from './style'
import { getRememberUser, rememberMe, removeRememberMe, removeUserDetails } from '../../util'
import { useGlobalStore } from '../../store'

const Login = (props) => {
  const form = useRef()
  const { setUser, setCompany } = useGlobalStore()

  const [loader, setLoader] = useState(false)
  const [serverErrorMsg, setServerErrorMsg] = useState()
  // const { enqueueSnackbar } = useSnackbar()

  const onSubmit = (data, isRemember) => {
    setLoader(true)
    AuthService.loginApi(data)
      .then((resp) => {
        let hasAskIa = null
        if( props.location.search.indexOf('?askia=') || props.location.pathname.indexOf('?askia=') ){
          console.log('props.location.search========', props.location.search, props.location )
          hasAskIa = props.location.search.length > 10 ? props.location.search : props.location.pathname
        }
        // console.log('resp========', resp, props, hasAskIa, '|||', props.location.search )
        if (resp?.user?.UserId) {
          setUser(resp.user)
          setCompany(resp.company)
          // console.log('redired========', ROUTE_PROJECTS+hasAskIa)
          props.history.push((hasAskIa) ? ROUTE_PROJECTS+hasAskIa : ROUTE_PROJECTS)
          // props.history.push(ROUTE_PROJECTS)
          // enqueueSnackbar('Logged in Successfully', {variant: 'success'})
        } else {
          setServerErrorMsg('Invalid Credentials')
        }
        if (isRemember) {
          rememberMe(data)
        } else {
          removeRememberMe()
        }
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
      })
      .finally(() => {
        setLoader(false)
      })
  }

  const validation = (values) => {
    const errors = {}
    if (!values.password) {
      errors.password = 'Password is required'
    }
    return errors
  }

  const isLocal = window.location.host.indexOf('localhost') !== -1

  const dummyCreds = [{ email: 'sewantil@mavenmagnet.com', password: 'test2-345' }]

  const formik = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: {
      email: isLocal ? dummyCreds[0].email : '',
      password: isLocal ? dummyCreds[0].password : '',
      rememberMe: false,
    },
    validationSchema: Yup.object({
      email: Yup.string().max(45).required('Email is required'),
      password: Yup.string().max(45).required('Password is required'),
    }),
    validate: (values) => validation(values),
    onSubmit: (values) => {
      const updatedValues = { ...values }
      const isRemember = updatedValues.rememberMe
      delete updatedValues.removeRememberMe
      onSubmit(updatedValues, isRemember)
    },
  })

  useEffect(() => {
    removeUserDetails()
    const rememberData = getRememberUser()
    if (rememberData?.userName && rememberData?.password) {
      formik.setValues({
        email: rememberData.userName,
        password: rememberData.password,
        rememberMe: true,
      })
    }
  }, [])

  useEffect(() => {
    localStorage.clear()
    localStorage.setItem('logs', JSON.stringify([]))
    localStorage.setItem('company', JSON.stringify({}))
    localStorage.setItem('user', JSON.stringify({}))
  }, [])

  return (
    <>
      <PreLogin>
        <form onSubmit={formik.handleSubmit} ref={form} autoComplete='off'>
          <EmailInputWrap>
            <MuiTextField
              error={Boolean(formik.touched.email && formik.errors.email)}
              fullWidth
              helperText={formik.touched.email && formik.errors.email}
              name='email'
              label='Email'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type='text'
              value={formik.values.email || ''}
              variant='standard'
              color='dark'
              sx={{
                '& input': {
                  fontSize: '16px !important',
                },
              }}
            />
          </EmailInputWrap>

          <PasswordInputWrap>
            <MuiTextField
              error={Boolean(formik.touched.password && formik.errors.password)}
              fullWidth
              helperText={formik.touched.password && formik.errors.password}
              name='password'
              label='Password'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              type='password'
              value={formik.values.password || ''}
              variant='standard'
              color='dark'
              // sx={{marginBottom:'15px', '& input': {
              //   fontSize: '16px !important'
              // }}}
            />
          </PasswordInputWrap>
          {serverErrorMsg && <ErrorMsg>{serverErrorMsg}</ErrorMsg>}

          <LoginContent1>
            <FormControlLabelWrapper
              name='rememberMe'
              checked={formik.values.rememberMe}
              onChange={formik.handleChange}
              control={<Checkbox />}
              label='Remember me'
              size='medium'
            />
            <MuiButton
              to={ROUTE_RESET_PASSWORD}
              variant='text'
              color='gray'
              size='small'
              style={{ fontWeight: 300 }}
            >
              Forgot Password?
            </MuiButton>
          </LoginContent1>

          <LoginButton
            variant='contained'
            color='secondary'
            type='submit'
            onClick={formik.handleSubmit}
            disabled={loader}
            endIcon={loader && <Loader />}
          >
            Sign In
          </LoginButton>

          <LoginContent2>
            <a href='/sso'>Sign in with SSO</a> <br />
            <br /> Don't have an account yet?{' '}
            <a href='https://www.mavenmagnet.com/contact' target='_blank' rel='noreferrer'>
              Contact Us
            </a>
          </LoginContent2>
        </form>
      </PreLogin>
    </>
  )
}

export default Login
